const mapSystemAlert = alert => ({
  level: alert.level,
  text: alert.text,
  pages: alert.pages,
})

const mapResponse = response => ({
  results: response.results ? response.results.map(mapSystemAlert) : response.results,
})

export const transformResponseGetSystemAlerts = response => (response ? mapResponse(response) : response)
